import Storage from "../data/storage"

const data = {
  favourites:[]
}

const load = () => {
  data.favourites = Storage.getFavourites()
  return data.favourites
}

const add = (activity_id) => {
  if(data.favourites.includes(activity_id)) {
    return data.favourites
  }
  const favourites = data.favourites.map(f => f)
  favourites.push(activity_id)
  data.favourites = favourites
  Storage.setFavourites(data.favourites)
  return data.favourites
}

const remove = (activity_id) => {
  const favourites = data.favourites.filter(a => a !== activity_id)
  data.favourites = favourites
  Storage.setFavourites(data.favourites)
  return data.favourites
}

const isFavourite = (activity_id) => {
  return data.favourites.includes(activity_id)
}

export default {load, add, remove, isFavourite}